import { ApolloLink } from "./ApolloLink.js";

/**
 * @deprecated Use `ApolloLink.split` instead. `split` will be removed in a
 * future major version.
 */
export const split = ApolloLink.split;
